import { CloseOutlined, ExclamationCircleFilled, InfoCircleFilled } from '@ant-design/icons';

import { colorConstants } from 'config/colorConstants';
import type { PPAPendingUserMessage } from 'types/ppaViews';

type SimulatorContextBannerProps = {
    messages: PPAPendingUserMessage[];
    onDismiss: (messageId: number) => void;
};

const BANNER_STYLE = {
    background: colorConstants.bannerWarningBg,
    border: colorConstants.bannerWarningBorder,
    icon: colorConstants.bannerWarningIcon,
} as const;

export function SimulatorContextBanner({ messages, onDismiss }: SimulatorContextBannerProps) {
    if (!messages.length) {
        return null;
    }

    return (
        <div className="absolute inset-x-0 bottom-0 z-20 flex flex-col">
            {messages.map((message) => {
                const isWarning = message.severity === 'warning';

                return (
                    <div
                        key={message.message_id}
                        className="flex items-center gap-2 border px-4 py-2 text-[13px] leading-5 text-fontColor"
                        style={{
                            background: BANNER_STYLE.background,
                            borderColor: BANNER_STYLE.border,
                        }}
                    >
                        {isWarning ? (
                            <ExclamationCircleFilled
                                className="shrink-0 text-base"
                                style={{ color: BANNER_STYLE.icon }}
                            />
                        ) : (
                            <InfoCircleFilled
                                className="shrink-0 text-base"
                                style={{ color: BANNER_STYLE.icon }}
                            />
                        )}
                        <span className="flex-1">{message.text}</span>
                        <button
                            type="button"
                            aria-label="Dismiss message"
                            onClick={() => onDismiss(message.message_id)}
                            className="shrink-0 cursor-pointer rounded p-0.5 text-fontColor/50 transition-colors hover:bg-black/5 hover:text-fontColor"
                        >
                            <CloseOutlined className="text-xs" />
                        </button>
                    </div>
                );
            })}
        </div>
    );
}

export default SimulatorContextBanner;
